import { fg } from '@atlaskit/platform-feature-flags';

import { type EditionAwarenessContextType } from './edition-awareness-context';
import type { useGetExperimentValue } from './experiment-context';

export function isEligibleForStandardTrialsUserAndStorageLimitBreakers(
	context: EditionAwarenessContextType,
	getExperimentValue: ReturnType<typeof useGetExperimentValue>['getExperimentValue'],
): boolean {
	const {
		product,
		edition,
		isInTrial,
		isInPredunning,
		invoiceableStatus,
		licensedUsers,
		canAddPaymentDetails,
		trialDaysLeft,
		storageUsageInGB,
		automationFreeLimitStatus,
	} = context;

	const isOnFirstTrialDay = !!(trialDaysLeft && trialDaysLeft === 14);
	const isOverUserLimit = licensedUsers > 10;
	const isOverStorageUsageLimit = !!(storageUsageInGB && storageUsageInGB > 2);

	if (fg('growth_automation_limits_kill_switch')) {
		if (automationFreeLimitStatus) {
			const cohort = getExperimentValue({
				statsigParams: {
					experimentName: 'growth_automation_limits_experiment',
					parameterName: 'cohort',
					defaultValue: 'not-enrolled',
					options: {
						fireExperimentExposure: false,
					},
				},
			});

			if (cohort !== 'not-enrolled') {
				return false;
			}
		}
	}

	if (
		product === 'confluence' &&
		edition === 'standard' &&
		fg('connie_edition_awareness_standard_trials_gate')
	) {
		return !!(
			(isInTrial || isInPredunning) &&
			invoiceableStatus === 'NOT_INVOICEABLE' &&
			canAddPaymentDetails &&
			!isOnFirstTrialDay &&
			(isOverUserLimit || isOverStorageUsageLimit)
		);
	}

	if (
		product === 'jira' &&
		edition === 'standard' &&
		fg('jira_edition_awareness_standard_trials_gate')
	) {
		return !!(
			isInTrial &&
			invoiceableStatus === 'NOT_INVOICEABLE' &&
			canAddPaymentDetails &&
			!isOnFirstTrialDay &&
			(isOverUserLimit || isOverStorageUsageLimit)
		);
	}

	return false;
}
